import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.scss']
})
export class SendSmsComponent implements OnInit {
  segmentations = JSON.parse(localStorage.getItem("segmentations")) || []

  constructor() { }

  ngOnInit() {
  }

}
